import { HTMLAttributes, ReactNode, createElement } from "react";
import styles from "./Heading.module.css";
import { cx } from "../utils";

export interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
    level?: 1 | 2 | 3 | 4;
    weight?: "medium" | "bold";
    children: ReactNode;
}

const levelClasses = {
    1: styles.level1,
    2: styles.level2,
    3: styles.level3,
    4: styles.level4
};

const weightClasses = {
    medium: styles.weightMedium,
    bold: styles.weightBold
};

export const Heading = ({ level = 2, weight = "bold", className, children, ...props }: HeadingProps) =>
    createElement(`h${level}`, { className: cx(styles.heading, levelClasses[level], weightClasses[weight], className), ...props }, children);
